export default __webpack_public_path__ + "static/media/math-sequencing.36e25fd5.gif";